export default __webpack_public_path__ + "static/media/bitcoin.a623fea0.webp";